'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { useRef, useState } from 'react'

import { TooltipFeedback } from './_tooltip/_tooltip-feedback'
import { IconButtonCore } from './icon-button'

type CopyState = 'IDLE' | 'SUCCESS' | 'FAILED'

function useCopyToClipboard({
  timeoutMs = 3000,
}: {
  /**
   * The amount of time to wait before resetting the state to IDLE
   * @default 3000
   */
  timeoutMs?: number
} = {}) {
  const [state, setState] = useState<CopyState>('IDLE')
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>(null)

  const copyToClipboard = async (textToCopy: string) => {
    try {
      await navigator.clipboard.writeText(textToCopy)
      setState('SUCCESS')
    } catch {
      setState('FAILED')
    } finally {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(() => setState('IDLE'), timeoutMs)
    }
  }

  return { state, copyToClipboard }
}

/**
 * A button to copy text to the clipboard with transient success/failure feedback.
 */
export function CopyButton({
  textToCopy,
  label = 'Copy to clipboard',
}: {
  textToCopy: string
  /**
   * Aria label for the button
   * @default 'Copy to clipboard'
   */
  label?: string
}) {
  const [isHoverOpen, setIsHoverOpen] = useState(false)
  const { state: copyState, copyToClipboard } = useCopyToClipboard()

  const tooltipTextMap: Record<typeof copyState, string> = {
    IDLE: label,
    SUCCESS: 'Copied!',
    FAILED: 'Copy failed',
  }

  const isFeedbackOpen = copyState !== 'IDLE'
  const tooltipOpen = isFeedbackOpen || isHoverOpen

  return (
    <TooltipFeedback
      help={tooltipTextMap[copyState]}
      open={tooltipOpen}
      onOpenChange={setIsHoverOpen}
    >
      <IconButtonCore
        iconName="heroicons/outline/document-duplicate"
        label={label}
        size="sm"
        onClick={() => copyToClipboard(textToCopy)}
      />
    </TooltipFeedback>
  )
}
